import { motion } from 'motion/react';
import { ScrollReveal } from '@/components/motion/scroll-reveal';
import { Target, Compass } from 'lucide-react';
import { values } from '../data/about-data';

export function AboutMission() {
  return (
    <section className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <ScrollReveal className="text-center mb-16">
          <p className="text-sm font-semibold text-blue-600 dark:text-blue-400 tracking-wider uppercase mb-3">
            Lo que nos mueve
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Mision, Vision y{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-violet-600">
              Valores
            </span>
          </h2>
        </ScrollReveal>

        {/* Mission & Vision cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-16">
          <ScrollReveal delay={0.1}>
            <div className="relative overflow-hidden rounded-2xl border border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900/50 p-8 h-full hover:shadow-xl hover:border-blue-200 dark:hover:border-blue-500/30 transition-all duration-300">
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/5 dark:bg-blue-500/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" />
              <div className="relative">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center mb-5 shadow-lg">
                  <Target className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                  Nuestra Mision
                </h3>
                <p className="text-gray-500 dark:text-gray-400 leading-relaxed">
                  Democratizar la inteligencia de precios para empresas en Latinoamerica. Que cada
                  empresa, sin importar su tamano, tenga acceso a herramientas de pricing de clase
                  mundial para competir en igualdad de condiciones.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.2}>
            <div className="relative overflow-hidden rounded-2xl border border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900/50 p-8 h-full hover:shadow-xl hover:border-violet-200 dark:hover:border-violet-500/30 transition-all duration-300">
              <div className="absolute top-0 right-0 w-32 h-32 bg-violet-500/5 dark:bg-violet-500/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" />
              <div className="relative">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-violet-500 to-purple-400 flex items-center justify-center mb-5 shadow-lg">
                  <Compass className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                  Nuestra Vision
                </h3>
                <p className="text-gray-500 dark:text-gray-400 leading-relaxed">
                  Ser la plataforma lider de pricing intelligence en la región. Queremos que cuando
                  una empresa en Latam piense en optimizar sus precios, Pricing Intelligence sea la
                  primera opción.
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>

        {/* Values grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <motion.div
                key={value.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group relative rounded-xl border border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900/50 p-6 hover:border-blue-200 dark:hover:border-blue-500/30 shadow-sm hover:shadow-xl transition-all duration-300 text-center"
              >
                <div
                  className={`w-12 h-12 rounded-lg bg-gradient-to-br ${value.gradient} flex items-center justify-center mx-auto mb-4 shadow-lg`}
                >
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                  {value.title}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                  {value.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
